import React from 'react';
import { VStack } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import FormInput from '../../../../../../components/form/FormInput';
import { inputTypes } from '../../../../../../components/form/FormInput/util';
import { getValidationObject } from '../../../../../../constants/regexPatterns';
import { useInsuredData } from '../../../../../../services/insured-service';
import UseFormMethodsType from '../../../../../../types/UseFormMethodsType';
import InsuredInfoPanel from '../InsuredInfoPanel';

const InsuredContact = ({ onClose, insuredId, useFormMethods, onSubmit }) => {
  const { data: insuredData } = useInsuredData(insuredId);

  const { handleSubmit } = useFormMethods;
  const formStack = [
    {
      name: 'insured_contact_name',
      placeholder: 'Contact Name',
      validation: { maxLength: { value: 150, message: 'Insured Contact Name must be fewer than 150 characters' } }
    },
    {
      name: 'insured_email',
      placeholder: 'Contact Email Address',
      required: true,
      validation: getValidationObject('emailAddress')
    },
    {
      name: 'insured_cc',
      placeholder: 'Email CC (comma separated)',
      validation: getValidationObject('commaSeparatedEmailAddress')
    }
  ];

  return (
    <InsuredInfoPanel
      isDisabled={insuredData?.deletedAt}
      title="insured contact"
      onClose={onClose}
      onSave={handleSubmit(onSubmit)}
    >
      <form>
        <VStack flexBasis="100%" mb="20px" pb={4} spacing={2}>
          {formStack.map(input => (
            <FormInput
              inputName={input.name}
              key={input.name}
              labelName={input.placeholder}
              placeholder={input.placeholder}
              required={input?.required}
              type={inputTypes.standard}
              useFormMethods={useFormMethods}
              validationRules={input?.validation}
            />
          ))}
        </VStack>
      </form>
    </InsuredInfoPanel>
  );
};

InsuredContact.propTypes = {
  onClose: PropTypes.func.isRequired,
  insuredId: PropTypes.number.isRequired,
  useFormMethods: UseFormMethodsType
};

export default InsuredContact;
